import { Box, Card, CardContent, Typography, Button, Avatar, Divider } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import LogTheme from './LogTheme';
import { useAuth } from '../../contexts/AuthContext';
import { getImageDisplayUrl } from '../../utils/api';

function ShowProfile() {
    const [profile, setProfile] = useState(null);
    const { userid } = useParams();
    const currentUser = useAuth();
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();


    console.log('currentUser i ShowProfile: ', currentUser.userId);

    useEffect(() => {
        if (userid !== currentUser.userId && currentUser.role !== 'admin') {
            setLoading(false);
            // Om userId inte är tillgängligt, vänta på nästa render för att göra fetch-anropet
            navigate('/info');
            return;
        }

        fetch(`${process.env.REACT_APP_SERVER_URL}/api/showprofile/${userid}`)
            .then(response => response.json())
            .then(data => {
                console.log('Response data:', data);
                setProfile(data);
            })
            .catch(error => {
                console.error('Error:', error);
            })
            .finally(() => setLoading(false));
    }, [userid, currentUser]);

    if (loading) {
        return <div>
            <h2 style={{ margin: 25 }}>Laddar sidan ...</h2></div>;
    }

    console.log('log ', profile);
    if (!profile) {
        return <div>
            <h2 style={{ margin: 25 }}>Profilen kunde inte hämtas.</h2>
        </div>;
    }

    // Hantera profilePictures - kan vara array, null eller undefined
    let profilePicturesArray = profile.profilePictures || [];
    if (typeof profilePicturesArray === 'string') {
      try {
        profilePicturesArray = JSON.parse(profilePicturesArray);
      } catch (e) {
        profilePicturesArray = [];
      }
    }
    if (!Array.isArray(profilePicturesArray)) {
      profilePicturesArray = [];
    }

    const mainProfilePicture = profilePicturesArray.length > 0 ? profilePicturesArray[0] : null;

    return (
        <LogTheme>
            <Box sx={{ maxWidth: '800px', margin: '0 auto', padding: { xs: 2, md: 4 } }}>
                <Box>
                    <Card sx={{ padding: 4, mb: 3 }}>
                        <CardContent>
                            <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={3}>
                                <Box>
                                    <Typography variant="h4" component="h1" gutterBottom>
                                        Min profil
                                    </Typography>
                                </Box>
                                <Link to={`/changeprofile/${userid}`}>
                                    <Button variant="contained" color="primary">Ändra</Button>
                                </Link>
                            </Box>

                            <Divider sx={{ mb: 4 }} />

                            {/* Profilinformation Section */}
                            <Box mb={4}>
                                <Typography variant="h5" gutterBottom>
                                    Profilinformation
                                </Typography>
                                <Typography variant="body2" color="text.secondary" gutterBottom sx={{ mb: 3 }}>
                                    Din profilinformation och profilbild
                                </Typography>

                                {/* Profile Picture */}
                                <Box display="flex" justifyContent="center" mb={4}>
                                    {mainProfilePicture ? (
                                        <Avatar
                                            src={getImageDisplayUrl(mainProfilePicture)}
                                            alt="Profilbild"
                                            sx={{ width: 150, height: 150 }}
                                        />
                                    ) : (
                                        <AccountCircleIcon sx={{ fontSize: 150, color: 'action.disabled' }} />
                                    )}
                                </Box>

                                {/* Email */}
                                <Box mb={3}>
                                    <Typography variant="body2" color="text.secondary" gutterBottom>
                                        E-post
                                    </Typography>
                                    <Typography variant="body1" sx={{ mb: 1 }}>
                                        {profile.email}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        E-postadressen kan inte ändras
                                    </Typography>
                                </Box>

                                {/* Name */}
                                <Box mb={3}>
                                    <Typography variant="body2" color="text.secondary" gutterBottom>
                                        Namn
                                    </Typography>
                                    <Typography variant="body1">
                                        {profile.firstName && profile.lastName 
                                            ? `${profile.firstName} ${profile.lastName}` 
                                            : profile.firstName || profile.lastName || profile.username || '-'}
                                    </Typography>
                                </Box>

                                {/* Bio/Description */}
                                {profile.bio && (
                                    <Box mb={3}>
                                        <Typography variant="body2" color="text.secondary" gutterBottom>
                                            Beskrivning
                                        </Typography>
                                        <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
                                            {profile.bio}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
            </Box>
        </LogTheme>
    );
}

export default ShowProfile;